import React from "react";
import { about, images } from "../../mock";
import useReveal from "../../hooks/useReveal";

export default function Intro({ onBook }) {
  const ref = useReveal();

  return (
    <section id="intro" ref={ref}>
      <div className="about-split">
        <div className="about-split-image" data-reveal="clip">
          <img src={images.portrait} alt="Юзлем Идриз — психолог" />
          <span className="photo-caption">
            Юзлем Идриз · психолог · психотелесен психотерапевт
          </span>
        </div>

        <div className="about-split-panel">
          <h1 className="split-heading" data-reveal>
            Понякога, за да <em>продължим напред</em>, трябва първо да се върнем към себе си.
          </h1>
          <p className="split-name" data-reveal>
            Юзлем Идриз · психолог и психотерапевт
          </p>
          <p className="split-tags" data-reveal>
            Раздяла · загуба · тревожност · житейски кризи
          </p>
          <button
            className="btn-outline-cream"
            onClick={() => onBook && onBook()}
            data-reveal
            data-testid="intro-book-btn"
          >
            Нека поговорим
          </button>
        </div>
      </div>
    </section>
  );
}
